var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "copy-field" }, [
    _c("p", { staticClass: "copy-label" }, [_vm._v(_vm._s(_vm.label))]),
    _c("div", { staticClass: "copy-box" }, [
      _c("span", { staticClass: "copy-value" }, [_vm._v(_vm._s(_vm.value))]),
      _c(
        "button",
        {
          staticClass: "copy-btn",
          attrs: { type: "button", title: `Copy ${_vm.label}` },
          on: {
            click: function ($event) {
              return _vm.$emit("copy")
            },
          },
        },
        [
          _vm.copied
            ? _c(
                "svg",
                {
                  staticClass: "icon-success",
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 16 16",
                    fill: "currentColor",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z",
                    },
                  }),
                ]
              )
            : _c(
                "svg",
                {
                  staticClass: "icon-copy",
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 16 16",
                    fill: "currentColor",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25v-7.5z",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5z",
                    },
                  }),
                ]
              ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }